import RecentPosts from "../components/News/RecentPosts";

function News() {
  return (
    <div className="App">
      <main>
        <RecentPosts />
      </main>
    </div>
  );
}

export default News;
